import { ReactNode } from "react";
import { PlannerDrawer, PlannerAppBar } from "../components/planner";

import * as React from "react";

import Box from "@mui/material/Box";

import { useLocation } from "react-router-dom";

import Toolbar from "@mui/material/Toolbar";
import { CssBaseline } from "@mui/material";

type PlannerLayoutProps = {
  children: ReactNode;
  title: string;
};

const drawerWidth = 256;

export const PlannerLayout = ({ children, title }: PlannerLayoutProps) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const [activeItem, setActiveItem] = React.useState("");

  React.useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("/planner/events/create")) {
      setActiveItem("Crear Evento");
    } else if (currentPath.includes("/planner/events")) {
      setActiveItem("Todos los Eventos");
    } else if (currentPath.includes("/planner/clients")) {
      setActiveItem("Clientes");
    } else if (currentPath.includes("/planner/organization")) {
      setActiveItem("Organizacion");
    } else if (currentPath.includes("/planner/help")) {
      setActiveItem("Help");
    } else {
      setActiveItem("Inicio");
    }
  }, [location]);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <PlannerAppBar
        title={title}
        drawerWidth={drawerWidth}
        handleDrawerToggle={handleDrawerToggle} 
      />

      <PlannerDrawer
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        handleDrawerTransitionEnd={handleDrawerTransitionEnd}
        handleDrawerClose={handleDrawerClose}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />

        {children}
      </Box>
    </Box>
  );
};
